
//métodos auxiliares usados na maiorias dos componentes
const componentMixin = {
    methods:{
        generateId(field) {
            return !!this.formOptions && this.formOptions.mode === 'list' ? `${this.formOptions.fieldIdPrefix}${field}` : field;
        },
    },

    computed: {
        idDynamic() {
            return this.hasGenerateDynamic ? this.schema.id : this.schema.model
        },
        hasGenerateDynamic () {
            return this.schema && 'fieldGenerateDynamic' in this.schema;
        }
    },
}

export default componentMixin;